import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { Dialog, Popover, Typography, Slider } from '@mui/material';
import {
  BORDER_RADIUS,
  BOX_SHADOW,
  BREAKPOINTS,
  MOBILE_BREAKPOINT,
} from '@src/styles/config';

export const StyledHome = styled('div')`
  width: 100%;
  margin-bottom: 16px;

  .box-voices {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 24px;
    padding: 0px;
    margin: 0px;
    border-radius: ${BORDER_RADIUS};
    margin: 8px 0px;
    height: fit-content;

    .box-home-title {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;

      .home-title {
        color: ${COLOR.darkBlue};
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
        word-wrap: break-word;
        font-style: normal;
        letter-spacing: -0.4px;
      }

      .generate-btn {
        min-height: 10px;
        min-width: 10px;
        height: 32px;
        width: 32px;
        padding: 0px;
        border-radius: 50%;

        .add-icon {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .number-voice-container {
    margin-left: auto;
    display: flex;
    gap: 4px;
  }

  .info-icon {
    font-size: 16px;
    padding: 4px;
    color: #1e164ea3;
  }

  .number-voice {
    color: rgba(28, 28, 30, 0.64);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .span-number-voice {
    color: ${COLOR.darkBlue};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: -0.4px;
  }

  @media only screen and (min-width: ${BREAKPOINTS.SM}px) {
    .box-voices {
      padding: 16px;
      background: ${COLOR.white};

      .box-home-title {
        gap: 16px;

        .home-title {
          line-height: 32px;
        }

        .generate-btn {
          height: 44px;
          width: 44px;

          .add-icon {
            width: 26px;
            height: 26px;
          }
        }
      }
    }
  }
`;

export const StyledVoicesInformation = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;

  .box-title-icon-btn {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    .title {
      color: ${COLOR.darkGray};
      font-size: 16px;
      font-weight: 700;
      line-height: 28px;
      word-wrap: break-word;
    }

    .sub-title {
      color: ${COLOR.label2[64]};
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;

      .span-sub-title {
        color: ${COLOR.indigo.default};
        font-size: 14px;
        line-height: 20px;
      }
    }

    .arrow-icon-btn {
      padding: 8px;
      min-width: 10px;
      min-height: 10px;
      width: 32px;
      height: 32px;
      color: ${COLOR.darkBlue};
      opacity: 0.72;
    }

    .arrow-icon-btn:focus {
      background: none;
    }
  }

  .voices {
    display: flex;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: space-between;
    gap: 16px;

    .voice {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 8px;
      padding: 12px;
      border-radius: ${BORDER_RADIUS};
      background: ${COLOR.charcoal};
      cursor: pointer;
      position: relative;

      .avatar {
        border: 1px solid ${COLOR.darkV2[64]};
        width: 80px;
        height: 80px;
        margin: auto;
      }

      .voice-info {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 4px;

        .name-info {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 4px;

          .name {
            color: ${COLOR.darkBlue};
            font-size: 16px;
            font-weight: 700;
            line-height: 24px;
            word-wrap: break-word;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }

        .category-info {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 4px;

          > * {
            color: ${COLOR.darkV2[64]};
            font-size: 14px;
            font-family: SF Pro;
            font-weight: 400;
            line-height: 20px;
            word-wrap: break-word;
          }
        }

        .status {
          padding-top: 4px;

          .processing-status {
            border-radius: 24px;
            padding: 4px 12px;
            width: fit-content;
            text-transform: none;
            background: ${COLOR.paleBlue};
            border: 1px solid ${COLOR.info};
            color: ${COLOR.info};

            .status-typo {
              font-size: 12px;
              font-family: SF Pro;
              font-weight: 510;
              line-height: 16px;
              word-wrap: break-word;
            }
          }

          .recording-status-btn {
            text-align: center;
            padding: 6px 10px;
            border-radius: 16px;
            width: 115px;
            background: ${COLOR.darkBlue};
            color: ${COLOR.white};
            text-transform: none;

            > * {
              font-size: 12px;
              font-weight: 510;
              line-height: 16px;
              word-wrap: break-word;
            }
          }
        }
      }

      .view-reason {
        position: absolute !important;
        bottom: 16px;
        right: 16px !important;

        .view-reason-text {
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: ${COLOR.bluev2[100]};
          text-decoration: underline;
        }
      }

      .use-now-button {
        position: absolute !important;
        bottom: 12px;
        right: 12px !important;
        text-transform: none;
        border-radius: 12px;

        .use-now-text {
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          color: ${COLOR.darkBlue};
        }
      }

      .more-horiz-btn {
        padding: 8px;
        min-width: 10px;
        min-height: 10px;
        width: 32px;
        height: 32px;
        color: ${COLOR.darkBlue};

        &.disabled {
          color: ${COLOR.indigo[64]};
        }
      }

      .redirect-btn {
        width: 32px;
        height: 32px;
        color: ${COLOR.indigo[64]};

        &.disabled {
          color: ${COLOR.indigo[64]};
        }
      }

      .icon-size-6 {
        font-size: 6px !important;
      }

      .icon-size-20 {
        font-size: 20px !important;
      }
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    gap: 8px;

    .voices {
      grid-template-columns: repeat(1, 1fr);

      .voice {
        .voice-info {
          .name-info {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            max-width: 200px;
          }

          .recording-status-btn {
            > * {
              white-space: nowrap;
              font-weight: 500;
            }
          }
        }

        .use-now-button {
          position: absolute !important;
          bottom: 12px;
          right: 12px !important;
          text-transform: none;
          border-radius: 12px;
          padding: 8px 16px !important;

          .use-now-text {
            font-weight: 700;
            font-size: 12px;
            line-height: 16px;
            color: ${COLOR.darkBlue};
          }
        }
      }
    }
  }

  .error-color {
    color: ${COLOR.functionalRed.default} !important;
  }
`;

export const StylePopover = styled(Popover)`
  .MuiPaper-root {
    border-radius: 16px;
  }
`;

export const StyledMoreButtonDialogMobile = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 580px;
    width: 100%;
    position: fixed;
    height: fit-content;
    padding-bottom: 24px;
    bottom: -35px;
    border-top-right-radius: 24px;
    border-top-left-radius: 24px;
  }

  .box-dialog {
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${COLOR.white};
    padding: 16px 24px;

    .box-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      border-bottom: 1px solid ${COLOR.darkV2[32]};

      .name-locale-info {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        gap: 4px;

        > * {
          color: ${COLOR.darkBlue};
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          word-wrap: break-word;
        }
      }

      .button-close {
        padding: 8px;
        min-width: 10px;
        width: 32px;
        height: 32px;
        color: ${COLOR.indigo[64]};
      }
    }

    .box-center {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .box-play-audio {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 16px;
        border-radius: ${BORDER_RADIUS};
        background: ${COLOR.darkV2[8]};
        height: 56px;
        padding: 0px 12px;

        .button-play {
          padding: 8px;
          min-width: 10px;
          min-height: 10px;
          width: 40px;
          height: 40px;
          background: ${COLOR.primary};
          color: ${COLOR.darkBlue};

          > * {
            font-size: 28px;
          }

          &.disabled {
            background: ${COLOR.yellow[32]};
            color: ${COLOR.indigo[64]};
          }
        }
      }

      .note-released {
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
        color: ${COLOR.info};
        text-align: center;
      }

      .use-now-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 510;
        line-height: 24px;
        color: ${COLOR.darkBlue};
        width: 100%;
        text-transform: none;
        border-radius: ${BORDER_RADIUS};
        height: 48px;

        &.disabled {
          background: ${COLOR.yellow[32]};
          color: ${COLOR.indigo[64]};
        }
      }

      .box-released {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        border-radius: ${BORDER_RADIUS};
        border: 1px solid ${COLOR.darkV2[32]};
        gap: 16px;

        &.disabled {
          border: 1px solid ${COLOR.darkV2[16]};
        }

        .released {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          gap: 32px;
          height: 48px;
          width: 95%;

          .released-text {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
            color: ${COLOR.darkBlue};
            font-weight: 510;
            line-height: 24px;

            &.disabled {
              color: ${COLOR.indigo[64]};
            }
          }
        }

        .radio-group {
          display: flex;
          flex-direction: row;
          justify-content: center;
          gap: 32px;
          width: 95%;
          background: ${COLOR.darkV2[8]};
          border-radius: ${BORDER_RADIUS};
          height: 48px;
          margin-bottom: 8px;
          color: ${COLOR.darkBlue};

          .radio {
            &.Mui-checked {
              color: ${COLOR.darkBlue};
            }
          }
        }
      }

      .rename-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 510;
        line-height: 24px;
        color: ${COLOR.darkBlue};
        width: 100%;
        text-transform: none;
        border-radius: ${BORDER_RADIUS};
        border: 1px solid ${COLOR.darkV2[32]};
        height: 48px;
      }
    }
  }
`;

export const StyledMoreButtonPopoverDesktop = styled('div')`
  .box-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${COLOR.white};
    padding: 16px;
    width: 270px;
    border-radius: 16px;
    box-shadow: ${BOX_SHADOW};

    .box-center {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .note-released {
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
        color: ${COLOR.info};
        text-align: center;
        width: fit-content;
        flex-wrap: nowrap;
      }

      .use-now-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        color: ${COLOR.darkBlue};
        width: 100%;
        text-transform: none;
        border-radius: ${BORDER_RADIUS};
        height: 48px;

        &.disabled {
          background: ${COLOR.yellow[32]};
          color: ${COLOR.indigo[64]};
        }
      }

      .box-released {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        border-radius: ${BORDER_RADIUS};
        border: 1px solid ${COLOR.darkV2[32]};

        &.disabled {
          border: 1px solid ${COLOR.darkV2[16]};
        }

        .released {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          gap: 32px;
          height: 48px;
          width: 95%;

          .released-text {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
            color: ${COLOR.darkBlue};
            font-weight: 510;
            line-height: 24px;

            &.disabled {
              color: ${COLOR.indigo[64]};
            }
          }
        }

        .radio-group {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          gap: 8px;
          width: 95%;
          background: ${COLOR.darkV2[8]};
          border-radius: ${BORDER_RADIUS};
          margin-bottom: 8px;
          color: ${COLOR.darkBlue};

          .radio {
            padding-left: 32px;

            &.Mui-checked {
              color: ${COLOR.darkBlue};
            }
          }
        }
      }

      .hear-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: ${COLOR.darkBlue};
        width: 100%;
        text-transform: none;
        border-radius: ${BORDER_RADIUS};
        border: 1px solid ${COLOR.darkV2[32]};
        height: 48px;

        &.disabled {
          color: ${COLOR.indigo[64]};
          border: 1px solid ${COLOR.darkV2[16]};
        }
      }

      .rename-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: ${COLOR.darkBlue};
        width: 100%;
        text-transform: none;
        border-radius: ${BORDER_RADIUS};
        border: 1px solid ${COLOR.darkV2[32]};
        height: 48px;
      }
    }
  }
`;

export const StyledChip = styled(Typography)`
  background-color: ${({ color }) => TRANSPARENT_COLOR[color]};
  color: ${({ color }) => COLOR[color]};
  text-align: center;
  align-items: center;
  padding: 5px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 510;
  white-space: nowrap;
  width: fit-content;
`;

export const StyledUnreleasedDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 580px;
    border-radius: 12px;
    width: 25%;
    height: auto;
    padding: 24px;
  }

  .box-dialog {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;

    .title {
      display: flex;
      justify-content: center;
      align-self: center;
      font-size: 16px;
      font-weight: 510;
      line-height: 24px;
      color: ${COLOR.darkBlue};
      padding: 0px;
    }

    .box-text {
      .note {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: ${COLOR.darkGray};
        text-align: center;
      }

      .warning {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: ${COLOR.red};
        text-align: center;
        padding-bottom: 8px;
      }
    }

    .text-field {
      width: 100%;

      .MuiInputBase-root {
        border-radius: 12px;
      }
    }

    .box-button {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      > * {
        border-radius: 24px;
        min-height: 10px;
        height: 44px;
        text-transform: none;
        width: 48%;
        color: ${COLOR.darkBlue};
        border: 1px solid ${COLOR.primary};
      }

      .agree {
        border: 1px solid ${COLOR.lightDivider};
      }
    }
  }
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .MuiDialog-paper {
      max-width: 580px;
      border-radius: 12px;
      width: 90%;
      height: auto;
      padding: 16px;
    }

    .box-dialog {
      display: flex;
      flex-direction: column;
      gap: 20px;
      justify-content: center;
      align-items: center;

      .title {
        display: flex;
        justify-content: center;
        align-self: center;
        font-size: 16px;
        font-weight: 510;
        line-height: 24px;
        color: ${COLOR.darkBlue};
        padding: 0px;
      }

      .box-text {
        .note {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: ${COLOR.darkGray};
          text-align: center;
        }

        .warning {
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: ${COLOR.red};
          text-align: center;
          padding-bottom: 8px;
        }
      }

      .text-field {
        width: 100%;

        .MuiInputBase-root {
          border-radius: 12px;
        }
      }

      .box-button {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        > * {
          border-radius: 24px;
          min-height: 10px;
          height: 44px;
          text-transform: none;
          width: 48%;
          color: ${COLOR.darkBlue};
          border: 1px solid ${COLOR.primary};
        }

        .agree {
          border: 1px solid ${COLOR.lightDivider};
        }
      }
    }
  }
`;

export const StyledRenameDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 580px;
    border-radius: 12px;
    width: 25%;
    height: auto;
    padding: 24px;
  }

  .box-dialog {
    display: flex;
    flex-direction: column;
    gap: 28px;
    justify-content: center;
    align-items: center;

    .box-input {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;

      .error {
        color: ${COLOR.error};
        font-size: 12px;
      }
    }

    .title {
      display: flex;
      justify-content: center;
      align-self: center;
      font-size: 16px;
      font-weight: 510;
      line-height: 24px;
      color: ${COLOR.darkBlue};
      padding: 0px;
    }

    .text-field {
      width: 100%;

      .MuiInputBase-root {
        border-radius: 12px;
      }
    }

    .box-button {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      > * {
        border-radius: 24px;
        min-height: 10px;
        height: 44px;
        text-transform: none;
        width: 48%;
        color: ${COLOR.darkBlue};
        border: 1px solid ${COLOR.primary};
      }

      .cancel {
        border: 1px solid ${COLOR.lightDivider};
      }

      .disabled {
        background: ${COLOR.yellow[32]};
        color: ${COLOR.darkV2[64]};
        border: 1px solid ${COLOR.yellow[32]};
      }
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .MuiDialog-paper {
      max-width: 580px;
      border-radius: 12px;
      width: 90%;
      height: auto;
      padding: 16px;
    }

    .box-dialog {
      display: flex;
      flex-direction: column;
      gap: 24px;
      justify-content: center;
      align-items: center;

      .title {
        display: flex;
        justify-content: center;
        align-self: center;
        font-size: 16px;
        font-weight: 510;
        line-height: 24px;
        color: ${COLOR.darkBlue};
        padding: 0px;
      }

      .text-field {
        width: 100%;

        .MuiInputBase-root {
          border-radius: 12px;
        }
      }

      .box-button {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        > * {
          border-radius: 24px;
          min-height: 10px;
          height: 44px;
          text-transform: none;
          width: 48%;
          color: ${COLOR.darkBlue};
          border: 1px solid ${COLOR.primary};
        }

        .cancel {
          border: 1px solid ${COLOR.lightDivider};
        }

        .disabled {
          background: ${COLOR.yellow[32]};
          color: ${COLOR.darkV2[64]};
          border: 1px solid ${COLOR.yellow[32]};
        }
      }
    }
  }
`;

export const StyledAudioSlider = styled(Slider)({
  color: COLOR.primary,
  height: 6,
  padding: 0,

  '& .MuiSlider-track': {
    border: 'none',
  },

  '& .MuiSlider-thumb': {
    height: '16px',
    width: '16px',
    backgroundColor: COLOR.white,
    border: `1px solid currentColor`,
  },

  '& .MuiSlider-rail': {
    color: COLOR.secondary[24],
  },
});

export const StyledActiveVoiceDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 16px;
    box-sizing: border-box;
  }

  .box-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px !important;
    border-bottom: 1px solid ${COLOR.darkV2[16]};

    .title {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
      color: ${COLOR.label2[100]};
    }

    .close-icon {
      width: 24px;
      height: 24px;
      color: ${COLOR.indigo[64]};
    }
  }

  .box-content {
    padding: 16px 24px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .box-content-warning {
      padding: 12px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 8px;
      background-color: ${COLOR.functionalRed[8]};

      .warning-icon {
        width: 24px;
        height: 24px;
        color: ${COLOR.functionalRed.default};
      }

      .warning-text {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;
        color: ${COLOR.label2[100]};
      }
    }

    .content {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      text-align: left;
      color: ${COLOR.label2[100]};
    }
  }

  .box-action {
    padding: 0px 16px 16px 16px !important;
    display: flex;
    gap: 8px;
    flex-direction: row;

    .action-btn {
      padding: 12px 48px;
      border-radius: 500px;
      color: ${COLOR.indigo[100]};
      background: ${COLOR.functionYellow.default};
      text-transform: none;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      border: 1px solid ${COLOR.functionYellow.default};
    }

    .no-btn {
      background-color: ${COLOR.white} !important;
      border: 1px solid ${COLOR.indigo[32]} !important;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .MuiDialog-paper {
      max-width: 580px;
      border-radius: 16px;
      width: 90%;
      height: auto;
    }

    .box-content {
      padding: 12px !important;
    }
  }
`;

export const StyledNewAudioSlider = styled(Slider)({
  color: COLOR.primary,
  height: 6,
  padding: 0,

  '& .MuiSlider-track': {
    border: 'none',
  },

  '& .MuiSlider-thumb': {
    display: 'none',
  },

  '& .MuiSlider-rail': {
    color: COLOR.secondary[24],
  },
});

export const StyledNewVoiceDetailInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;

  .avatar-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    position: relative;

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      object-fit: cover;
      border: 1px solid ${COLOR.darkV2[16]};
    }

    .name {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      color: ${COLOR.darkBlue};
    }

    .close-btn {
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 50%;
      padding: 8px;
      background: ${COLOR.indigo[16]};
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .close-icon {
        width: 16px;
        height: 16px;
      }
    }
  }

  .audio-sample-wrapper {
    display: flex;
    padding: 8px 12px 8px 12px;
    gap: 12px;
    border-radius: 12px;
    border: 1px solid ${COLOR.darkV2[16]};
    justify-content: center;
    align-items: center;
    opacity: ${({ disabledInteract }) => (disabledInteract ? 0.5 : 1)};

    .button-play {
      padding: 8px;
      min-width: 10px;
      min-height: 10px;
      width: 40px;
      height: 40px;
      background: ${COLOR.primary};
      color: ${COLOR.darkBlue};
    }

    .disabled {
      background: ${COLOR.darkV2[16]};
      color: ${COLOR.indigo[64]};
    }
  }

  .active-audio-wrapper {
    padding: 16px 12px;
    border-radius: 12px;
    border: 1px solid ${COLOR.darkV2[16]};
    display: flex;
    flex-direction: column;
    gap: 12px;
    opacity: ${({ disabledInteract }) => (disabledInteract ? 0.5 : 1)};

    .title-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: ${COLOR.darkGray};
      }
    }

    .note {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: ${COLOR.black[64]};
    }

    .error {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: ${COLOR.functionalRed.default};
    }

    .use-now-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      color: ${COLOR.darkBlue};
      width: 100%;
      text-transform: none;
      border-radius: ${BORDER_RADIUS};
      height: 48px;
    }
  }

  .voice-info-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-radius: 12px;
    border: 1px solid ${COLOR.darkV2[16]};
    cursor: pointer;

    .title {
      font-size: 16px;
      font-weight: 510;
      line-height: 24px;
      text-align: left;
      color: ${COLOR.secondary[100]};
    }

    .icon {
      width: 24px;
      height: 24px;
    }
  }

  .delete-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: ${COLOR.functionalRed.default} !important;
    width: 100%;
    text-transform: none;
    border-radius: ${BORDER_RADIUS};
    height: 48px;
    border: 1px solid ${COLOR.functionalRed.default} !important;
    opacity: ${({ isDisabledDelete }) =>
      isDisabledDelete ? 0.5 : 1} !important;
  }
`;

export const StyledNewDialogVoiceDetailMobile = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 580px;
    width: 100%;
    position: fixed;
    height: fit-content;
    padding-bottom: 24px;
    bottom: -35px;
    border-top-right-radius: 24px;
    border-top-left-radius: 24px;
  }
`;

export const StyledNewDialogVoiceDetailDesktop = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 580px;
    width: 100%;
    border-radius: 16px;
  }
`;

export const StyledViewReason = styled(Dialog)`
  .MuiDialog-paper {
    min-width: 340px;
    border-radius: 16px;
    padding: 0px !important;
  }
  .dialog-title {
    padding: 16px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${COLOR.darkV2[16]};

    .title {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
      color: ${COLOR.black.default};
    }

    .close-button {
      width: 24px;
      height: 24px;
    }
  }

  .dialog-content {
    padding: 12px 24px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .reason {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: ${COLOR.label2[100]};
    }

    .contact {
      font-style: italic;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: ${COLOR.label2[64]};

      a {
        color: ${COLOR.bluev2[100]};
      }
    }
  }

  .dialog-actions {
    padding: 12px 24px 12px 16px;

    .button {
      border-radius: 500px;
      text-transform: none;
      font-weight: 700;
      padding: 8px 12px !important;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .dialog-title {
      padding: 16px;
      .title {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-align: left;
      }
    }

    .dialog-content {
      padding: 12px 16px !important;
      .reason {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;
      }
    }
  }
`;

export const StyledEditVoiceInformation = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;

  .edit-title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }

    .edit-title {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
      color: ${COLOR.secondary[100]};
    }
  }

  .avatar-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    position: relative;

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      object-fit: cover;
      border: 1px solid ${COLOR.darkV2[16]};
      cursor: pointer;
    }

    .edit-icon {
      position: absolute;
      bottom: 0;
      right: calc(50% - 40px);
      border-radius: 50%;
      padding: 4px;
      background: ${COLOR.indigo[64]};
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .icon {
        width: 16px;
        height: 16px;
        color: ${COLOR.white};
      }
    }
  }

  .info-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .info-field-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
      border-radius: 12px;
      padding: 16px 12px;
      border: 1px solid ${COLOR.darkV2[16]};

      .field-title {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: ${COLOR.label2[100]};
      }

      .field-value {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: ${COLOR.label2[100]};
      }

      .icon-edit {
        width: 16px;
        height: 16px;
        color: ${COLOR.darkBlue};
        opacity: 0.64;
      }

      .text-field {
        .MuiInputBase-root {
          .MuiInputBase-input {
            padding: 0px !important;
            outline: none;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            text-align: right;
          }

          .MuiOutlinedInput-notchedOutline {
            border: none;
          }
        }
      }

      .gender-box-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-radius: 8px;
        background: ${COLOR.white};
        border: 1px solid ${COLOR.darkV2[32]};

        .gender-button {
          display: flex;
          width: 72px;
          height: 36px;
          padding: 0px 12px;
          justify-content: center;
          align-items: center;
          align-self: stretch;
          text-transform: none;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: -0.4px;
          color: ${COLOR.darkV2[32]};
          border-radius: 0;

          &.button-right {
            border-right: 1px solid ${COLOR.darkV2[32]};
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          }

          &.button-left {
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        }

        .selected {
          background: ${COLOR.darkV2[16]};
          color: ${COLOR.black.default};
        }
      }

      .locale-box-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-radius: 8px;
        background: ${COLOR.white};
        border: 1px solid ${COLOR.darkV2[32]};

        .locale-button {
          display: flex;
          width: fit-content;
          height: 36px;
          padding: 0px 12px;
          justify-content: center;
          align-items: center;
          align-self: stretch;
          text-transform: none;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: -0.4px;
          color: ${COLOR.darkV2[32]};
          border-radius: 0;

          &.northern {
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          }

          &.central {
            border-right: 1px solid ${COLOR.darkV2[32]};
            border-left: 1px solid ${COLOR.darkV2[32]};
          }

          &.southern {
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        }

        .selected {
          background: ${COLOR.darkV2[16]};
          color: ${COLOR.black.default};
        }
      }

      .province-button {
        display: flex;
        text-transform: none;
        font-size: 16px;
        min-height: 10px;
        min-width: 10px;
        height: 36px;
        padding: 0px 10px;

        &.MuiButton-root:hover {
          background: ${COLOR.white};
        }

        .select {
          color: ${COLOR.darkV2[64]};
          border: none;
          background: none;
          padding: 0px;
        }

        .disabled {
          color: ${COLOR.darkV2[32]};
          border: none;
          background: none;
          padding: 0px;
        }

        .province {
          color: ${COLOR.black.default};
          border: none;
          background: none;
          padding: 0px;
        }

        .loading {
          width: 24px;
          height: 24px;
          padding-left: 4px;
        }

        .icon {
          width: 24px;
          height: 24px;
          padding-left: 4px;
          color: ${COLOR.darkV2[64]};
        }
      }

      .province-button:focus {
        background: none;
      }
    }

    .select-box {
      padding: 9px 12px !important;
    }
  }

  .save-button {
    text-transform: none;
    color: ${COLOR.secondary[100]};
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    border-radius: 12px;
    min-height: 48px;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 0px;
    position: relative;

    .edit-title-wrapper {
      padding: 24px 24px 16px 24px;
      background: ${COLOR.white};
    }

    .avatar-wrapper {
      padding: 16px;

      .edit-icon {
        bottom: 10px;
      }
    }

    .info-wrapper {
      padding: 0px 16px;

      .info-field-wrapper {
        background: ${COLOR.white};

        .text-field {
          width: 60%;
        }
      }
    }

    .save-button {
      position: fixed;
      bottom: 16px;
      left: 16px;
      width: calc(100% - 32px);
      border-radius: 500px;
      padding: 12px;
    }
  }
`;

export const StyledEditVoiceInformationMobile = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 580px;
    width: 100%;
    height: 100%;
    position: fixed;
    margin: 0px !important;
    max-height: 100%;
    background-color: ${COLOR.charcoal};
  }
`;

export const StyledProvincesListMobile = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 400px;
    width: 100%;
    height: 40%;
    border-radius: 24px;
  }

  .box-dialog {
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${COLOR.white};
    padding: 16px 24px;
    overflow: hidden;

    .box-search {
      .search {
        padding-top: 16px;
        .MuiOutlinedInput-root {
          border-radius: ${BORDER_RADIUS};
          height: 45px;
        }
      }
    }

    .provinces {
      flex: 1;
      overflow-y: auto;
      border-radius: ${BORDER_RADIUS};
      border: 1px solid ${COLOR.darkV2[32]};

      ::-webkit-scrollbar {
        width: 8px;
      }

      ::-webkit-scrollbar-thumb {
        background: ${COLOR.darkV2[32]};
        border-radius: 8px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: ${COLOR.darkV2[64]};
      }

      .province {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: ${COLOR.darkGray};
        width: 100%;
        text-transform: none;
        border-radius: 0;
        border-top: 1px solid ${COLOR.darkV2[32]};

        &.first {
          border-top: none;
        }
      }
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .MuiDialog-paper {
      max-width: 580px;
      width: 100%;
      height: 60%;
      position: fixed;
      bottom: -35px;
      border-top-right-radius: 24px;
      border-top-left-radius: 24px;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
`;

export const StyledProvincesListDesktop = styled('div')`
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  right: 48px;
  border-radius: 12px;
  background: ${COLOR.white};
  z-index: 10000;
  max-width: 250px;
  box-shadow: 0px 4px 16px 0px ${COLOR.black[16]};
  box-sizing: border-box;

  .search {
    display: flex;
    padding: 2px 16px !important;
    border-bottom: 1px solid ${COLOR.darkV2[32]};
    box-sizing: border-box;

    .MuiOutlinedInput-root {
      padding: 0px !important;
      .MuiOutlinedInput-notchedOutline {
        border: none;
      }
    }
  }

  .provinces {
    display: flex;
    flex-direction: column;
    height: 200px;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 8px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${COLOR.darkV2[32]};
      border-radius: 8px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.darkV2[64]};
    }

    .province {
      display: flex;
      height: 44px;
      padding: 8px 16px;
      align-items: center;
      gap: 12px;
      align-self: stretch;
      text-transform: none;
      color: ${COLOR.black.default};
    }
  }
`;
